export default __webpack_public_path__ + "static/media/Usuario.8c56c656.svg";